export const LABELS = {
  isSecuredPropertySameAsApplicantAddress:
    "Is the secured property the same as the applicant's 1st residential address?",
  address: "Full address of the property",
  addressLine1: "Address Line 1",
  addressLine2: "Address Line 2",
  addressLine3: "Address Line 3",
  townOrCity: "Town or city",
  county: "County",
  postcode: "Postcode",
  propertyType: "What type of property is this?",
  propertyStyle: "Property style",
  groundRentIfFlat:
    "If the property is a flat, what is the ground rent (monthly)",
  noOfBedrooms: "Number of bedrooms",
};
